export const constants = {
  FETCH_TOKEN: 'FETCH_TOKEN',
  CLEAR_VARIABLES: 'CLEAR_VARIABLES',
  DELETE_LEAD: 'DELETE_LEAD',
};
